export default __webpack_public_path__ + "static/media/booked.9ea94b7a.svg";